export default "assets/pattern-1ff17f0e.jpg";